class LiveChatCountries {
  CountryList = [
    { CountryID: 'A29633', LangID: 'de' }
    // ,
    // { CountryID: '687465', LangID: 'ar' },
    // { CountryID: '687852', LangID: 'br' },
    // { CountryID: 'A49072', LangID: 'cl' },
    // { CountryID: '688955', LangID: 'co' },
    // { CountryID: '688954', LangID: 'pe' }
  ];
}

export default new LiveChatCountries();
